import {
  IMPACT_LEVELS,
  URGENCY_LEVELS,
  getImpactLevel,
  getPriorityMeta,
  getUrgencyLevel,
} from '../../utils/priorityMatrix'
import '../../styles/ticket-form.css'

/** Control segmentado para un nivel (impacto o urgencia). */
const LevelSegment = ({ label, question, levels, value, onSelect }) => {
  const current = levels.find((l) => l.value === Number(value)) || levels[1]
  return (
    <div className="col-12 col-sm-6">
      <label className="at-label">
        {label}
        <span className="at-label-q">{question}</span>
      </label>
      <div className="at-segment" role="radiogroup" aria-label={label}>
        {levels.map((lvl) => {
          const active = Number(value) === lvl.value
          return (
            <button
              key={lvl.value}
              type="button"
              role="radio"
              aria-checked={active}
              title={lvl.hint}
              className={`at-segment-btn ${active ? 'is-active' : ''}`}
              onClick={() => onSelect(lvl.value)}
              style={active ? { color: lvl.color } : undefined}
            >
              {lvl.label}
            </button>
          )
        })}
      </div>
      {/* La explicación del nivel se muestra siempre (el tooltip no existe en móvil). */}
      <p className="at-level-hint">{current.hint}</p>
    </div>
  )
}

/**
 * Impacto × Urgencia y la prioridad que se deriva de ambos.
 *
 * @component
 * @param {Object} props
 * @param {number} props.impact
 * @param {number} props.urgency
 * @param {number} props.priorityId - Prioridad ya derivada.
 * @param {(changes: {impact?: number, urgency?: number}) => void} props.onChange
 * @param {(id: number) => string} [props.priorityLabel] - Nombre según catálogo.
 * @returns {JSX.Element}
 */
const ImpactUrgencyPicker = ({
  impact,
  urgency,
  priorityId,
  onChange,
  priorityLabel = (id) => getPriorityMeta(id).label,
}) => {
  const priorityMeta = getPriorityMeta(priorityId)

  return (
    <>
      <div className="row g-3">
        <LevelSegment
          label="Impacto"
          question="¿A cuántos afecta?"
          levels={IMPACT_LEVELS}
          value={impact}
          onSelect={(v) => onChange({ impact: v })}
        />
        <LevelSegment
          label="Urgencia"
          question="¿Qué tan pronto?"
          levels={URGENCY_LEVELS}
          value={urgency}
          onSelect={(v) => onChange({ urgency: v })}
        />
      </div>

      <div
        className="at-priority"
        style={{
          borderColor: `${priorityMeta.color}55`,
          background: `${priorityMeta.color}0f`,
        }}
      >
        <span className="at-priority-label">
          <span>
            <i className="fa-solid fa-wand-magic-sparkles me-2" />
            Prioridad calculada
          </span>
          <span className="at-priority-formula">
            Impacto {getImpactLevel(impact).label} × Urgencia{' '}
            {getUrgencyLevel(urgency).label}
          </span>
        </span>
        <span
          className="at-priority-badge"
          style={{
            color: priorityMeta.color,
            background: `${priorityMeta.color}1f`,
          }}
        >
          <i className="fas fa-circle me-1" style={{ fontSize: '7px' }} />
          {priorityLabel(priorityId)}
        </span>
      </div>
    </>
  )
}

export default ImpactUrgencyPicker
